<template>
<div>
  <div justify="center" >
     <v-card class=" mt-4 mx-auto" max-width="1000" min-width="300">
          <v-img
          class="white--text"
          height="300px"
          src="https://images.unsplash.com/photo-1501630834273-4b5604d2ee31?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
        >
          <v-container bg fill-height grid-list-md text-xs-center>
        <v-layout row wrap align-center>
       <v-flex xs6 class="place">
          <v-text-field
          xs3
          dark
          color="pink lighten-3"
           class="centered-input text--pink-lighten-3 mt-3" 
            v-model="Code"
            label="Kod"
            outline
          ></v-text-field>
        </v-flex>
          <v-flex>
                        <div justify="center" class="text-xs-center">
                                      <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <v-btn fab dark large :disabled="Code==''"  
                  v-bind="attrs"
                  v-on="on" color="red" @click="open('kränk')">
      <v-icon dark>sentiment_very_dissatisfied</v-icon>
    </v-btn>
    
              </template>
              <span>Kränkningsanmälan</span>
            </v-tooltip>
            
            <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
           <v-btn fab dark large 
                  v-bind="attrs"
                  v-on="on" :disabled="Code==''"  color="blue" @click="open('vissla')">
      <v-icon dark>sports</v-icon>
    </v-btn>      
     </template>
              <span>Vissla</span>
            </v-tooltip>

            <v-tooltip bottom>
<template v-slot:activator="{ on, attrs }">
            <v-btn fab dark large 
                  v-bind="attrs"
                  v-on="on" :disabled="Code==''"  color="green" @click="open('mående')">
      <v-icon dark>self_improvement</v-icon>
    </v-btn>
 </template>
              <span>Måendekoll</span>
            </v-tooltip>

        </div>
     <!-- <div class="headline">   Måendekoll! </div> -->
          </v-flex>
        </v-layout>
      </v-container>
     </v-img>

<whistle :schoolCode="Code" :school="school"  v-if="value=='vissla'" />
<krank :schoolCode="Code"  :schoolId="school.id"  v-else-if="value=='kränk'"/>
<feeling :schoolCode="Code"  :feeling="feeling" v-else-if="value=='mående'"/>    


  <!-- <http://localhost:8080/login#/whistle/N0BJcW1Km0a8GNdwxYX5x9Jxa053 />
  http://localhost:8080/#/whistle/N0BJcW1Km0a8GNdwxYX5x9Jxa053
  http://localhost:8080/whistle#/login
                      
  
   -->
  </v-card>
    </div>
</div>
</template>

<script>
// import classrooms from '../components/classrooms'
import { mapActions, mapGetters } from 'vuex'
import Feeling from './feeling.vue';
import Krank from './krank.vue';
import Whistle from './whistle.vue';

export default {
   props: {
    schoolId: String
  },
    data: () => ({

        value: "",
      loaded:false,
      output:{},
      send:false,
      reciever2: [],
      message: "",
      Code:"",
      oldSchoolcode:"",
      Hide: false,
      change:false,
      NewAnswer:{},//{med:"",sch:"", sleep:""},
       questions:[{Q:"Har du tagit dina mediciner?", short:"med", ans:"y"},{Q:"Har du varit eller ska du till skolan idag?", short:"sch", ans:"y"},{Q:"Har du ätit mat i skolan idag?", short:"food", ans:"y"},
        {Q:"Hur många timmar har du sovit i natt?", short:"sleep", ans:"ten"}],
        colors: ["red lighten-1","pink lighten-1","purple lighten-2","blue lighten-1","light-green lighten-1","light-green lighten-3"]
      // membernameandId: ["Ulla,Kurator","Frank,Skolchef","Roger,Rektor","Lena,SYV"]

  }),

  watch: {
    feeling: function (val) {
     this.Hide=true;
      this.oldSchoolcode=this.Code
        this.change=true;
    },
  },

  methods: {


    ...mapActions('ehtmembers', ['logoutEHT','initEHT']),
    ...mapActions('schools', ['getSchool']),
    ...mapActions('feeling', ['getFeeling','updateFeeling']),


      
feelingscheck(feeling)
{
if (feeling.hasOwnProperty('feelings')) {
  let lastDate = new Date( feeling.feelings[feeling.feelings.length - 1].date )
  let Today= new Date()
  if (lastDate.getDate==Today.getDate) {
    return false;
  }
//   else
// return true;
}
return true;
},


update(){
  //console.log(this.feeling)
if(!this.feeling.hasOwnProperty('feelings') )
{
  this.feeling.feelings=[];
}
let out= this.output;
  out.date= Date.now();
  this.feeling.feelings.push(out)
  this.updateFeeling(this.feeling)
this.Hide=false;
},

test(cat,input){
this.output[cat] = input;
  //console.log(this.output)
},
    open(value){
//console.log(value)
this.value= value;
if (value=="vissla" ||value=="kränk") {
//console.log(this.school)

       if (this.school==null || this.oldSchoolcode!=this.Code) {
        this.logoutEHT();
      this.getSchool(this.Code);
      }
}
else if(value=="mående")
{
    //console.log(this.feeling)
     if (this.feeling==null || this.oldSchoolcode!=this.Code) {
        // this.logoutEHT();
      this.getFeeling(this.Code);
       
      }
}
    //   //console.log(this.Hide)
    //   if (this.Hide==false) {
    //     //console.log(this.feeling)
    //   if (this.feeling==null || this.oldSchoolcode!=this.Code) {
    //     // this.logoutEHT();
    //   this.getFeeling(this.Code);
       
    //   }
    //   else
    //   this.Hide=!this.Hide;
    //   }
    //   else
    //   this.Hide=!this.Hide;
    },
  
  },
    computed: {
   
    // ...mapGetters('ehtmembers', ['membernameandId']),
        ...mapGetters('schools', ['school']),
    ...mapGetters('feeling', ['feeling']),

  },
  components: {
    Whistle,
    Feeling,
    Krank
  }

    }
</script>
<style scoped>
 .centered-input >>> input {
      text-align: center;
      color:green;
       font-size: 2em;

    }
  .place{
          width: 50%;
      margin-right: 25%;
      margin-left: 25%;
  }

</style>
